<template>
  <form-wrap
    class="client-settings"
    @submit="handleUpdate"
  >
    <section-title v-t="'p.clientSettingsPage.title'"/>
    <form-field-set>
      <text-input
        v-model="workspace"
        :error="fieldError('update', 'workspace')"
        :label="$t('p.clientSettingsPage.form.label.workspace')"
        name="workspace"
      />

      <text-input
        v-model="name"
        :error="fieldError('update', 'name')"
        :label="$t('p.clientSettingsPage.form.label.name')"
        name="name"
      />

      <file-input
        :error="fieldError('update', 'logo')"
        :label="$t('p.clientSettingsPage.form.label.logo')"
        :label-placeholder="$t('p.clientSettingsPage.form.label.logo_placeholder')"
        name="clientLogo"
        @change="selectLogo"
      />

      <editor-input
        v-if="shouldShowBody"
        v-model="emailSignature"
        :label="$t('p.clientSettingsPage.form.label.email_signature')"
        :error="fieldError('update', 'emailSignature')"
        name="emailSignature"
      />

      <switch-input
        v-model="signupEnabled"
        :error="fieldError('update', 'signupEnabled')"
        :label="$t('p.clientSettingsPage.form.label.signup_enabled')"
        :hint="$t('p.clientSettingsPage.form.label.signup_enabled_hint')"
        name="signupEnabled"
      />
    </form-field-set>

    <form-actions>
      <button-input
        v-t="'p.clientSettingsPage.form.action.submit'"
        type="submit"
      />
    </form-actions>
  </form-wrap>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import NotificationsMixin from '@/mixins/notifications/notifications'
import PageMixin from '@/mixins/pages/Page'

export default {
  name: 'ClientSettings',
  mixins: [
    FormMixin,
    NotificationsMixin,
    PageMixin
  ],
  props: {
    shouldShowBody: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState ({
      currentUser: state => state.currentUser.currentUser,
    }),
    ...mapGetters({
      currentClient: 'currentClient',
      fieldError: 'clientForm/fieldError',
      tagsOptions: 'tagsOptions'
    }),
    name: {
      get () { return this.$store.state.clientForm.form.name },
      set (value) { this.$store.dispatch('clientForm/setName', value) }
    },
    workspace: {
      get () { return this.$store.state.clientForm.form.workspace },
      set (value) { this.$store.dispatch('clientForm/setWorkspace', value) }
    },
    signupEnabled: {
      get () { return this.$store.state.clientForm.form.signupEnabled },
      set (value) { this.$store.dispatch('clientForm/setSignupEnabled', value) }
    },
    emailBlacklist: {
      get () { return this.$store.state.clientForm.form.emailBlacklist },
      set (value) { this.$store.dispatch('clientForm/setEmailBlacklist', value) }
    },
    emailWhitelist: {
      get () { return this.$store.state.clientForm.form.emailWhitelist },
      set (value) { this.$store.dispatch('clientForm/setEmailWhitelist', value) }
    },
    theme: {
      get () {
        const fallback = JSON.stringify(this.$store.state.client.theme)
        const theme = this.$store.state.clientForm.form.theme || fallback

        return theme
      },
      set (value) { this.$store.dispatch('clientForm/setTheme', value) }
    },
    logo: {
      get () { return this.$store.state.clientForm.form.logo },
      set (value) { this.$store.dispatch('clientForm/setLogo', value) }
    },
    emailSignature: {
      get () { return this.$store.state.clientForm.form.emailSignature },
      set (value) { this.$store.dispatch('clientForm/setEmailSignature', value) }
    },
    tags: {
      get () { return this.$store.state.clientForm.form.tags },
      set (value) { this.$store.dispatch('clientForm/setTags', value) }
    }
  },
  methods: {
    ...mapActions({
      show: 'clientForm/show',
      update: 'clientForm/update',
      resetUpdateErrors: 'clientForm/resetUpdateErrors',
      fetchCurrentUser: 'fetchCurrentUser',
      loadingDone: 'app/loadingDone'
    }),
    selectLogo (event) {
      this.$store.dispatch('clientForm/setLogo', event.target.files[0])
    },
    addTag (value) {
      this.$store.dispatch('clientForm/setTags', value)
    },
    handleUpdate () {
      return this.update({ clientId: this.currentClient.id })
        .then(this.fetchCurrentUser)
        .then(this.resetUpdateErrors)
        .then(this.savedNotification)
        .catch(this.somethingWentWrongNotification)
    }
  },
  created () {
    this.show({ clientId: this.currentClient.id })
      .then(() => {
        if (this.currentUser.role !== 'owner') {
          this.$router.push({ name: 'ClientTags' })
        }

        this.loadingDone()
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/clients/ClientSettingsPage.vue